import React, { useState } from "react";
import {
  FaqDynamicZoneModel,
  OneFaqModel,
} from "@models/strapi-components/faq-dynamic-zone";
import Accordian from "@components/common/Accordian";
import VizWrapper from "@components/common/Base/VizWrapper";
import Title from "@components/common/Title";

export interface FaqComponentPropsModel {
  componentData: FaqDynamicZoneModel;
}
const FaqComponent: React.FunctionComponent<FaqComponentPropsModel> = ({
  componentData,
}) => {
  const { faqs, title } = componentData;
  const [openFaqId, setOpenFaqId] = useState("");

  const handleClick = (id: string) => {
    if (openFaqId === id) {
      setOpenFaqId("");
    } else {
      setOpenFaqId(id);
    }
  };

  const renderOneFaq = (faq: OneFaqModel) => {
    const { question, answer, id } = faq;
    return (
      <Accordian
        header={question}
        body={answer?.data?.childMarkdownRemark?.html ?? <></>}
        isOpen={id === openFaqId}
        handleClick={() => {
          handleClick(id);
        }}
        bodyWrapperClassName="max-w-[718px]"
        headerClassName="text-lg font-medium leading-[24px] xl:text-2xl mb-2"
        wrapperClassName="xl:pb-5"
      />
    );
  };

  return (
    <VizWrapper className="max-w-[972px] mx-auto">
      <Title variant="h2" titleText={title} className="text-center mb-8" />
      <div className="w-full">
        {faqs?.map((oneFaq) => (
          <div key={oneFaq?.id}>{renderOneFaq(oneFaq)}</div>
        ))}
      </div>
    </VizWrapper>
  );
};

export default FaqComponent;
